import React, { useState, useEffect } from "react";
import { clearSession } from "../shared/_helpers/session";
import { checkBlockedStatus, getAllUserList, getUsersListByAdvisorId,blockUnblockUser } from "../shared/_services/common.services";
import TableComponent from "./TableComponent";
import { useSnackbar } from "notistack";
import Loader from "./Loader";
import { useNavigate,Link } from "react-router-dom";
import Pagination from "./Pagination";

import Modal from "react-bootstrap/Modal";

const UserList = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [userData, setUserData] = useState([]);
  const role = JSON.parse(localStorage.getItem("currentUser"))?.user?.userType;
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const [confirmBlockPopupShow, setConfirmBlockPopupShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [blockAction, setBlockAction] = useState('');


  const headers = {
    "advisor": ["Name", "Subscription Type", "E-mail", "Member Since"],
    "super-admin": ["Name", "Financial Advisor", "Subscription Type", "E-mail","Block","Member Since"],
    "admin": ["Name", "Financial Advisor", "Subscription Type", "E-mail", "Member Since","Block"]
  };


  const getUsersData = async () => {
    setShowLoader(true);

    let response;
    if (role === "advisor") {
      response = await getUsersListByAdvisorId(JSON.parse(localStorage.getItem("currentUser"))?.user?._id);
    } else {
      response = await getAllUserList("client");
    }

    if (response.status === 200) {
      setUserData(response.data);
    } else {
      if (response?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("Your session has been expired!", {
          variant: "error",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        navigate("/login");
      }
    }

    setShowLoader(false);
  };

  const checkBlocked = async () => {
    const userId = JSON.parse(localStorage.getItem('currentUser')).user?._id;
    try {
      // Call the API to check the user's blocked status
      const response = await checkBlockedStatus(userId);
      
      if (response.data ? response.status == 401 : response.response.status == 401) {
        clearSession();
        navigate("/login");
      }
      else {
        const { isBlocked, isDeleted } = response.data;

        if (isBlocked || isDeleted) {
          // Clear the currentUser from localStorage
          clearSession();

          // Navigate to the login page
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error checking blocked status:", error);
      // Optionally handle errors, e.g., show an error message
    }
  }

  const confirmBlockPopupClose = () => setConfirmBlockPopupShow(false);

  const openConfirmBlockPopup = (user) => {
    setSelectedUser(user);
    setBlockAction(user.status ? 'block' : 'unblock'); // assuming status = true means active
    setConfirmBlockPopupShow(true);
  };

  const handleBlock = async () => {
  setConfirmBlockPopupShow(false);
  setShowLoader(true);
  const userId = selectedUser._id;
  const newStatus = !selectedUser.status; // toggles

  try {
    await blockUnblockUser({ userId, status: newStatus });
    getUsersData();
    const action = newStatus ? "unblocked" : "blocked";
    enqueueSnackbar(`Client ${action} successfully`, { variant: "success" });
  } catch (error) {
    const action = newStatus ? "unblock" : "block";
    enqueueSnackbar(`Failed to ${action} client`, { variant: "error" });
  } finally {
    setShowLoader(false);
  }
};



  useEffect(() => {
    checkBlocked();
    getUsersData();
  }, []);

  //pagination code
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = userData.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(userData.length / recordsPerPage)

  return (
    <>
      <div className="page-header">
        <h2>Clients</h2>
      </div>
      <div className="px-4 py-4">
        {showLoader ? <Loader /> :
          <>
            <TableComponent headers={headers[role]} data={currentRecords} test={"temp"} onBlockUserClick={openConfirmBlockPopup}/>
            <Pagination
              nPages={nPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </>}
      </div>

      <Modal
        size="md"
        className="confirmBlockPopup customMiniPopup"
        show={confirmBlockPopupShow}
        onHide={confirmBlockPopupClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <div className="modal-body">
          <div className="d-flex justify-content-between">
            <h4 className="mt-3"></h4>
            <Link className="close-popup-btn" onClick={confirmBlockPopupClose}>
              <i className="fa fa-times"></i>
            </Link>
          </div>
          <h4 className="mt-3 mb-3 text-center">
            {`You are attempting to ${blockAction === 'block' ? 'block' : 'unblock'} ${selectedUser ? selectedUser.firstName : ''
              }.`}
          </h4>
          <h5 className="text-center f-700">Are you sure?</h5>
          <div className="text-center mt-4 mb-3">
            <button className="as-btn-primary w-75" onClick={handleBlock}>
              {blockAction === 'block' ? 'Block' : 'Unblock'}
            </button>
          </div>
        </div>
      </Modal>

    </>
  );
};

export default UserList;